import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.js';
import Loading from '../components/Loading.js';

interface Props {
  children: ReactNode;
  /** require is_admin === true */
  adminOnly?: boolean;
}

export default function RequireAuth({ children, adminOnly = false }: Props) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="mx-auto max-w-6xl px-6 py-16">
        <Loading label="正在登录…" />
      </div>
    );
  }
  if (status === 'anonymous') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (adminOnly && !user?.is_admin) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
